import {
    BingGifValue,
    getHttpsGifs,
    logQPSExceeded,
    QPS_LIMIT_HTTP_STATUS_CODE,
} from './getGifSearchResults';
import { HttpReadyState, HttpStatusCode } from 'owa-http-status-codes';
import { trace } from 'owa-trace';

interface BingGifTrendingResponse {
    categories: BingGifTrendingCategory[];
}
interface BingGifTrendingCategory {
    title: string;
    tiles: BingGifTrendingTile[];
}
interface BingGifTrendingTile {
    image: BingGifValue;
}

const POPULAR_GIF_TITLE = 'Popular gif searches';
const BING_TRENDING_GIF_URL =
    'https://www.bing.com/api/v6/images/trending?appId=D41D8CD98F00B204E9800998ECF8427E61385B59&setmkt=en-us';

/**
 * Get Gif trending results
 */
function getGifTrendingResults(): Promise<BingGifValue[]> {
    return new Promise((resolve, reject) => {
        // CELA approved to use en-us for all markets
        // Since the trending API only takes en- markets, we will default to en-us
        let url = BING_TRENDING_GIF_URL;
        let request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.onreadystatechange = function () {
            if (request.readyState === HttpReadyState.Done) {
                let response: any = null;
                let results: BingGifValue[] = [];
                if (request.status === HttpStatusCode.OK) {
                    try {
                        response = JSON.parse(request.response) as BingGifTrendingResponse;
                        response.categories.forEach((value: BingGifTrendingCategory) => {
                            if (value.title == POPULAR_GIF_TITLE) {
                                value.tiles.forEach((value: BingGifTrendingTile) => {
                                    results.push(value.image);
                                });
                            }
                        });

                        // Only allow images served over https://
                        let httpsResults: BingGifValue[] = getHttpsGifs(results);

                        resolve(httpsResults);
                    } catch (ex) {
                        trace.warn('Unable to parse gif trending response');
                        reject(ex);
                    }
                } else {
                    if (request.status == QPS_LIMIT_HTTP_STATUS_CODE) {
                        logQPSExceeded();
                    }

                    reject(
                        new Error(
                            'Request failed with status ' +
                                request.status +
                                '. Message: ' +
                                request.responseText
                        )
                    );
                }
            }
        };
        request.send();
    });
}

export default getGifTrendingResults;
